"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[464],{

/***/ 22464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ApplicationForm; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42283);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37636);
/* harmony import */ var _hooks_useGtm__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(75882);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31955);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_Divider__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88204);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(98456);
/* harmony import */ var _LoginModal_LoginModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53706);
/* harmony import */ var _context_AppStateContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7095);
/* harmony import */ var _context_DispatchContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83594);
/* harmony import */ var _api_iskibris_client__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13032);



















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ApplicationForm(props) {
    var tagEvent = (0,_hooks_useGtm__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().tagEvent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref6[0], setLoading = ref6[1];
    var AuthState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_AppStateContext__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).AuthState;
    var AuthDispatcher = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context_DispatchContext__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).AuthDispatcher;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), serverErrors = ref1[0], setServerErrors = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), authErrors = ref2[0], setAuthErrors = ref2[1];
    var SignupSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
        name: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required(),
        phone_number: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().matches(/\+?\d+$/).required(),
        company_name: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required(),
        email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
        option: yup__WEBPACK_IMPORTED_MODULE_5__/* .number */ .Rx().required().nullable()
    });
    var ref3 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        validationSchema: SignupSchema
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.errors, setError = ref3.setError, setValue = ref3.setValue, clearErrors = ref3.clearErrors, watch = ref3.watch;
    function getIskibrisProfile() {
        return _getIskibrisProfile.apply(this, arguments);
    }
    function _getIskibrisProfile() {
        _getIskibrisProfile = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _api_iskibris_client__WEBPACK_IMPORTED_MODULE_12__/* ["default"].get */ .Z.get("/api/user/profile").then(function(response) {
                            var user = response.data;
                            AuthDispatcher({
                                type: "addUser",
                                payload: user
                            });
                        }).catch(function(error) {});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _getIskibrisProfile.apply(this, arguments);
    }
    var handleSuccess = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        AuthDispatcher({
                            type: "login"
                        });
                        _ctx.next = 3;
                        return getIskibrisProfile();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSuccess() {
            return _ref.apply(this, arguments);
        };
    }();
    // const token = Cookies.get("auth_token")
    // checking if props is true
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (AuthState.isLoggedIn && !AuthState.user) {
            _api_iskibris_client__WEBPACK_IMPORTED_MODULE_12__/* ["default"].get */ .Z.get("/api/user/profile").then(function(response) {
                var user = response.data;
                setValue("name", user.full_name);
                setValue("phone_number", user.phone_number);
                setValue("email", user.email);
                AuthDispatcher({
                    type: "login"
                });
                AuthDispatcher({
                    type: "addUser",
                    payload: user
                });
            }).catch(function(error) {});
        }
    }, [
        AuthState.isLoggedIn,
        AuthDispatcher,
        AuthState.user,
        setValue
    ]);
    var url = (0,_lib_api__WEBPACK_IMPORTED_MODULE_6__/* .getIskibrisUrl */ .nV)("/api/employers/apply");
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, e) {
            var application;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        setServerErrors({});
                        setAuthErrors({});
                        setLoading(true);
                        application = {
                            name: data.name,
                            phone_number: data.phone_number.toString().replaceAll(" ", ""),
                            company_name: data.company_name,
                            email: data.email,
                            option: data.option,
                            password: data.password
                        };
                        _ctx.next = 7;
                        return axios__WEBPACK_IMPORTED_MODULE_4___default().post(url, application, {
                            headers: {
                                "Accept": 'application/json'
                            }
                        }).then(function(res) {
                            if (application.option === "1") {
                                tagEvent({
                                    event: "generate_lead",
                                    data: {
                                        company_name: application.company_name
                                    }
                                });
                                var _NEXT_PUBLIC_APP_DOMAIN;
                                js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].set */ .Z.set("auth_token", res.data.auth_token, {
                                    domain: (_NEXT_PUBLIC_APP_DOMAIN = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN : ".iskibris.com",
                                    sameSite: "None",
                                    secure: true,
                                    expires: 364
                                });
                                var _NEXT_PUBLIC_APP_DOMAIN1;
                                js_cookie__WEBPACK_IMPORTED_MODULE_8__/* ["default"].set */ .Z.set("is_employer", "true", {
                                    domain: (_NEXT_PUBLIC_APP_DOMAIN1 = ".iskibris.com") !== null && _NEXT_PUBLIC_APP_DOMAIN1 !== void 0 ? _NEXT_PUBLIC_APP_DOMAIN1 : ".iskibris.com",
                                    sameSite: "None",
                                    secure: true,
                                    expires: 750
                                });
                                AuthDispatcher({
                                    type: "login"
                                });
                            }
                            setLoading(false);
                            AuthDispatcher({
                                type: "login"
                            });
                            router.push("/success");
                        }).catch(function(error) {
                            var ref, ref4, ref5;
                            tagEvent({
                                event: "company_activation_failed",
                                data: {
                                    user_name: application.name,
                                    company_name: application.company_name,
                                    error_code: error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status
                                }
                            });
                            if (!(error === null || error === void 0 ? void 0 : error.response)) {
                                setServerErrors(_objectSpread({}, serverErrors, {
                                    application_error: "Bir hata oluştu, internet bağlantınızın olduğunu teyit edip tekrar deneyiniz. aynı hata oluşmaya devam ediyorsa l\xfctfen destek takımımıza ulaşınız."
                                }));
                            }
                            if ((error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 500) {
                                setServerErrors(_objectSpread({}, serverErrors, {
                                    server_error: "Bilinmeyen bir hata oluştu, aynı hata oluşmaya devam ediyorsa l\xfctfen destek takımımıza ulaşınız."
                                }));
                            }
                            if ((error === null || error === void 0 ? void 0 : (ref5 = error.response) === null || ref5 === void 0 ? void 0 : ref5.status) === 401) {
                                setAuthErrors(_objectSpread({}, authErrors, {
                                    authentication_error: "Kimlik bilgileriniz kayıtlarımızla eşleşmedi."
                                }));
                            }
                            if (error.response.data.errors) {
                                Object.keys(error.response.data.errors).forEach(function(key) {
                                    if (key === "message") {
                                        setServerErrors(_objectSpread({}, serverErrors, {
                                            generic_error: error.response.data.errors[key]
                                        }));
                                    } else {
                                        setError(key, {
                                            type: "server",
                                            message: error.response.data.errors[key]
                                        });
                                    }
                                });
                            }
                            setLoading(false);
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data, e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "form",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__title",
                children: "Başvuru Formu"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__subtitle",
                children: "Formu doldurun, İş Kıbrıs Hesabınızı oluşturalım"
            }),
            serverErrors.generic_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.generic_error
                })
            }),
            serverErrors.application_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.application_error
                })
            }),
            serverErrors.server_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__error--panel",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: serverErrors.server_error
                })
            }),
            authErrors.authentication_error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: (authErrors === null || authErrors === void 0 ? void 0 : authErrors.authentication_error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    variant: "text",
                    style: {
                        textTransform: "none"
                    },
                    href: "/forgot-password",
                    fullWidth: true,
                    children: "Şifremi unuttum?"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "form__group",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    autoFocus: true,
                    type: "text",
                    id: "company_name",
                    name: "company_name",
                    label: "Firma Adı",
                    size: "small",
                    variant: "outlined",
                    inputRef: register({
                        required: {
                            value: true,
                            message: "Bu alan gereklidir."
                        }
                    })
                })
            }, "form-group"),
            errors.company_name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "form__error",
                children: errors.company_name.message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                className: "form__inner",
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            id: "name",
                            type: "text",
                            label: "Ad Soyad",
                            name: "name",
                            size: "small",
                            variant: "outlined",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                }
                            })
                        })
                    }),
                    errors.name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.name.message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            id: "phone_number",
                            size: "small",
                            variant: "outlined",
                            label: "Telefon Numaranız",
                            type: "tel",
                            name: "phone_number",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                },
                                pattern: {
                                    value: /\+?\d+$/,
                                    message: "L\xfctfen doğru bir telefon numarası giriniz."
                                }
                            })
                        })
                    }),
                    errors.phone_number && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.phone_number.message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            id: "email",
                            label: "E-posta",
                            type: "text",
                            name: "email",
                            variant: "outlined",
                            size: "small",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                },
                                pattern: {
                                    value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: "L\xfctfen doğru bir email giriniz"
                                }
                            })
                        })
                    }),
                    errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.email.message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            id: "password",
                            label: "Şifre",
                            type: "password",
                            size: "small",
                            variant: "outlined",
                            name: "password",
                            inputRef: register({
                                required: {
                                    value: true,
                                    message: "Bu alan gereklidir."
                                }
                            })
                        })
                    }),
                    errors.password && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "form__error",
                        children: errors.password.message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        style: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", {
                            name: "option",
                            className: "form__control",
                            ref: register,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                    value: "",
                                    children: "---"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                    value: "1",
                                    selected: true,
                                    children: "Benim i\xe7in deneme oluştur"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "form__group",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            type: "submit",
                            style: {
                                background: "#e61e8f",
                                color: "white"
                            },
                            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                size: "30px",
                                style: {
                                    color: "white"
                                }
                            }) : "G\xf6nder"
                        }, Math.random())
                    }),
                    props.showLoginButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "form__group",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Divider__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                orientation: "horizontal",
                                sx: {
                                    color: "#221133"
                                },
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        variant: "body1",
                                        children: " veya"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_LoginModal_LoginModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                onSuccess: handleSuccess,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        size: "small",
                                        onClick: props.OpenForm,
                                        variant: "text",
                                        sx: {
                                            color: "#e61e8f",
                                            marginTop: "10px",
                                            textTransform: "none"
                                        },
                                        children: "Giriş"
                                    })
                                }, "login-button")
                            })
                        ]
                    }, "buttons-container")
                ]
            }, "form-inner")
        ]
    }));
};


/***/ }),

/***/ 75882:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var useGtm = function() {
    var tagEvent = function(param) {
        var event = param.event, data = param.data;
        if (true) {
            window.dataLayer.push(_objectSpread({
                event: event
            }, data));
        }
    };
    return {
        tagEvent: tagEvent
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGtm);


/***/ }),

/***/ 37636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "pK": function() { return /* binding */ getStrapiURL; },
/* harmony export */   "nV": function() { return /* binding */ getIskibrisUrl; },
/* harmony export */   "cD": function() { return /* binding */ fetchEmployersAPI; }
/* harmony export */ });
/* unused harmony export fetchAPI */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function getStrapiURL() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat("https://strapi.iskibris.com" || 0).concat(path);
}
function getIskibrisUrl() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat("https://api.iskibris.com" || 0).concat(path);
}
// Helper to make GET requests to Strapi
function fetchAPI(path) {
    return _fetchAPI.apply(this, arguments);
}
function _fetchAPI() {
    _fetchAPI = _asyncToGenerator(regeneratorRuntime.mark(function _callee(path) {
        var requestUrl, response, data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requestUrl = getStrapiURL(path);
                    _ctx.next = 3;
                    return fetch(encodeURI(requestUrl));
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchAPI.apply(this, arguments);
}
function fetchEmployersAPI(path) {
    return _fetchEmployersAPI.apply(this, arguments);
}
function _fetchEmployersAPI() {
    _fetchEmployersAPI = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(path) {
        var requestUrl, response, data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requestUrl = getIskibrisUrl(path);
                    _ctx.next = 3;
                    return fetch(encodeURI(requestUrl));
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchEmployersAPI.apply(this, arguments);
}


/***/ })

}]);